import { Box, Skeleton, Stack } from "@mui/material";

const ProductDetailsSkeleton = () => {
  return (
    <div className="w-full h-full flex items-center justify-center flex-col pt-10">
      <div className="w-[95%] flex flex-col lg:flex-row gap-10">
        {/* Left Column - Images */}
        <div className="w-full lg:flex-2 flex flex-col gap-2">
          <Skeleton variant="rectangular" className="w-full !h-[400px] mb-2" />
          <div className="flex gap-2 mt-3 items-center justify-center">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                className="w-[8vw] !h-[8vw] object-cover"
              />
            ))}
          </div>
        </div>

        <div className="lg:flex-1 flex flex-col gap-4">
          <Skeleton variant="text" width="30%" height={30} />
          <Skeleton variant="text" width="70%" height={40} />
          <Skeleton variant="text" width="50%" height={20} />
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton variant="rectangular" width="100%" height={50} />
          <Stack direction="row" spacing={2} mt={2}>
            <Skeleton variant="rectangular" width="48%" height={40} />
            <Skeleton variant="rectangular" width="48%" height={40} />
          </Stack>
        </div>
      </div>

      <div className="w-[95%] flex flex-col lg:flex-row gap-5 mt-10">
        <div className="lg:flex-2 flex flex-col gap-2 border p-4">
          <Skeleton variant="text" width="30%" height={40} />
          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="90%" height={20} />
        </div>

        <div className="lg:flex-1 flex flex-col gap-4 border p-4">
          <Skeleton variant="circular" width={56} height={56} />
          <Skeleton variant="text" width="60%" height={25} />
          <Skeleton variant="text" width="80%" height={20} />
          <Stack direction="row" spacing={2} mt={2}>
            <Skeleton variant="rectangular" width="48%" height={36} />
            <Skeleton variant="rectangular" width="48%" height={36} />
          </Stack>
        </div>
      </div>

      <div className="productsGrid mt-10">
        {Array.from({ length: 4 }).map((_, index) => (
          <Box key={index} sx={{ width: 300, margin: 1 }}>
            <Skeleton variant="rectangular" width="100%" height={180} />
            <Skeleton variant="text" width="80%" height={25} />
            <Skeleton variant="text" width="50%" height={20} />
          </Box>
        ))}
      </div>
    </div>
  );
};

export default ProductDetailsSkeleton;
